export default {
  id: "topSellingDepartments",
  name: "",
  description: "",
  report: {
    name: "Top Selling Departments",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Department",
      dimensions: ["Department.name"],
      measures: ["SaleItem.units_sold"],
      sort: {
        direction: "desc",
        by: "SaleItem.units_sold",
      },
      filters: [
        {
          member: "Department.name",
          operator: "notContains",
          values: ["Customer Charges", "POS payment surcharges"],
        },
        {
          member: "Department.name",
          operator: "set",
        },
      ],
      compare: true,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
